import React from 'react';
import { Layout, Row, Col, Typography } from "antd";
import { themeColors } from 'theme';
const { Text } = Typography;
const { Content } = Layout;

const TransferTableComponent = (props) => {
    const { data } = props;
    const [feesData, setFeesData] = React.useState([]);

    React.useEffect(() => {
        if (data) {
            const fees = Object.entries(data).map(([key, value]) => ({
                fee: value.description,
                qtd: value.qtd,
                value: value.fee.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
            })).sort((a, b) => a.fee.localeCompare(b.fee, 'pt-BR'));
            setFeesData(fees);
        }
    }, [data]);

    return (
        <Content style={styles.container}>
            <Row style={styles.header}>
                <Col span={10}><Text style={styles.headerText}>Tarifa</Text></Col>
                <Col span={4} style={{ display: 'flex', justifyContent: 'center' }}>
                    <Text style={styles.headerText}>Qtd.</Text>
                </Col>
                <Col span={10} style={{ display: 'flex', justifyContent: 'center' }}>
                    <Text style={styles.headerText}>Ganho</Text>
                </Col>
            </Row>
            {feesData.map((item, index) => (
                <Row key={index} style={styles.row}>
                    <Col span={10}><Text style={styles.cell}>{item.fee}</Text></Col>
                    <Col span={4} style={{ display: 'flex', justifyContent: 'center' }}>
                        <Text style={styles.cell}>{item.qtd}</Text>
                    </Col>
                    <Col span={10} style={{ display: 'flex', justifyContent: 'center' }}>
                        <Text style={styles.cell}>{item.value}</Text>
                    </Col>
                </Row>
            ))}
        </Content>
    );
};

const styles = {
    container: {
        padding: 16,
        backgroundColor: themeColors.softColor,
        borderRadius: 8,
    },
    header: {
        borderBottom: '1px solid #ddd',
        paddingBottom: 8,
        marginBottom: 8,
    },
    headerText: {
        fontWeight: 'bold',
        color: themeColors.mediumColor,
    },
    row: {
        padding: '8px 0',
        display: 'flex',
        alignItems: 'center',
    },
    cell: {
        color: themeColors.mediumColor,
        marginRight: 0,
        paddingRight: 0,
    },
};

export default TransferTableComponent;
